export const HOME = {
  emergentLink: "home-emergent-link",
  startBtn: "landing-start-btn",
  adminBtn: "landing-admin-btn",
  langToggle: "lang-toggle",
};

export const MAGAZINE = {
  root: "magazine-root",
  next: "magazine-next-btn",
  prev: "magazine-prev-btn",
  chapterCard: (id) => `magazine-chapter-${id}`,
  quizAnswer: (i) => `quiz-answer-${i}`,
  quizSubmit: "quiz-submit",
};

export const GAMES = {
  root: "games-root",
  gameCard: (k) => `game-card-${k}`,
  option: (i) => `game-option-${i}`,
  submit: "game-submit",
};

export const STORIES = {
  root: "stories-root",
  storyCard: (id) => `story-card-${id}`,
  choice: (i) => `story-choice-${i}`,
};

export const EXAM = {
  root: "exam-root",
  nameInput: "exam-name-input",
  startBtn: "exam-start-btn",
  option: (i) => `exam-option-${i}`,
  next: "exam-next",
  finish: "exam-finish",
  restart: "exam-restart",
  downloadCert: "exam-download-cert",
};

export const AUTH = {
  loginBtn: "login-btn",
  logoutBtn: "logout-btn",
};

export const ADMIN = {
  navDashboard: "admin-nav-dashboard",
  navExams: "admin-nav-exams",
  navResponses: "admin-nav-responses",
  navEmployees: "admin-nav-employees",
  navQuestions: "admin-nav-questions",
  createExamBtn: "admin-create-exam-btn",
  createExamSubmit: "admin-create-exam-submit",
  examTitleEs: "admin-exam-title-es",
  examTitleEn: "admin-exam-title-en",
  examTimeLimit: "admin-exam-time-limit",
  copyLinkBtn: (slug) => `admin-copy-link-${slug}`,
  exportExcel: "admin-export-excel",
  exportPdf: "admin-export-pdf",
  filterEmployee: "admin-filter-employee",
  filterExam: "admin-filter-exam",
  questionRow: (id) => `admin-question-row-${id}`,
  saveQuestion: "admin-save-question",
};
